module.exports = [{"name":"Презентация 2026","file":"/static/files/presentations/2026_alcomet.pdf","img":"/static/files/presentations/2026_alcomet.jpg","date":"06.09.2026"}]


//////////////////
// WEBPACK FOOTER
// ./src/components/download-center/dpresentations.json
// module id = rKSy
// module chunks = 1